module.exports = __webpack_public_path__ + "img/morality.ac502f3d.png";